/*
 * Get the browser window location.
 */
export const useLocation: () => Location = () => {
  return window.location;
};
